import { isLeoThinkingQuestion } from "@/lib/leo-blueprint-section-fill"

/** Fields every paper-count surface already has. */
export type PaperCountRow = {
  leoThinking?: boolean
  sectionId?: string
  status?: string
  points?: number
}

/**
 * On the paper for totals, KPIs, and coverage. Drafts count; Leo thinking
 * placeholders and unassigned rows do not.
 */
export function isSettledPaperQuestion(row: PaperCountRow): boolean {
  if (row.sectionId === "?") return false
  return !isLeoThinkingQuestion(row)
}

export function settledPaperQuestions<T extends PaperCountRow>(
  rows: readonly T[],
): T[] {
  return rows.filter(isSettledPaperQuestion)
}

export function paperQuestionCount(rows: readonly PaperCountRow[]): number {
  return settledPaperQuestions(rows).length
}

export function paperQuestionPoints(rows: readonly PaperCountRow[]): number {
  return Number(
    settledPaperQuestions(rows)
      .reduce((sum, row) => sum + (row.points || 0), 0)
      .toFixed(1),
  )
}

export function paperDraftCount(rows: readonly PaperCountRow[]): number {
  return settledPaperQuestions(rows).filter((row) => row.status === "Draft")
    .length
}
